document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll('.wp-block-orla-plus-animated-sentence')
		.forEach((block) => {
			const words = block.querySelectorAll('.animated-word');
			let index = 0;

			const delay = 600;

			const interval = setInterval(() => {
				if (!words[index]) {
					clearInterval(interval);
					return;
				}
				words[index].classList.add('is-visible');
				index++;
			}, delay);
		});
});
